export default __webpack_public_path__ + "static/media/BTN.86a34f50.svg";